import React from "react";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { getValueMora } from "services/Payments";
import { getUserInfo } from "services/Payments";

const ValidateUser = ({ setFormConfig, setUser, setMora }) => {
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm();

  const OnSubmit = handleSubmit(async (data) => {
    try {
      const response = await getUserInfo(data);

      // El backend respondió, pero no encontró la información necesaria
      if (response?.success === false) {
        return toast(
          (t) => (
            <section className="supportToast">
              <button
                type="button"
                onClick={() => toast.dismiss(t.id)}
                className="supportToast__close"
                aria-label="Cerrar mensaje"
              >
                <i className="fa-solid fa-xmark"></i>
              </button>

              <header>
                <h2>¡Atención!</h2>
              </header>

              <p>
                {response.message ||
                  "No se encontró información para continuar."}
              </p>

              <p>
                Si necesitas ayuda, puedes contactar a nuestro soporte a través
                de WhatsApp:
              </p>

              <a
                href="https://api.whatsapp.com/send?phone=5717945996&text=Buen%20d%C3%ADa%20%20%0ARequiero%20ayuda"
                target="_blank"
                role="button"
                aria-label="Contactar a soporte por WhatsApp"
                rel="noopener noreferrer"
              >
                Contactar a Soporte
              </a>

              <p>
                Nuestro equipo estará encantado de ayudarte a resolver cualquier
                inconveniente.
              </p>
            </section>
          ),
          {
            duration: 60000,
          },
        );
      }

      // Si la respuesta sí contiene los datos del usuario, continuamos
      setUser(response);

      const resp = await getValueMora(response.codigo);
      setMora(resp);

      setFormConfig({ step: 2 });
    } catch (error) {
      console.error(error);

      toast.error(
        error.response.data.message ||
          "Ocurrió un error. Por favor, inténtelo nuevamente.",
      );
    }
  });

  return (
    <form onSubmit={OnSubmit}>
      <div className={errors?.cedula && "ErrorContainer"}>
        <label className="mb-2" htmlFor="cedula">
          Ingrese su número de identificación
        </label>
        <input
          id="cedula"
          className="inputPay"
          {...register("cedula", {
            required: {
              value: true,
              message: "Debe ingresar su número de identificación",
            },
          })}
        />
        {errors?.cedula && (
          <span className="errorForm">
            <i className="fa-solid fa-circle-exclamation"></i>
            {errors?.cedula.message}
          </span>
        )}
      </div>

      <button disabled={isSubmitting} className="MercadoPago mt-3">
        {isSubmitting ? (
          <span className="spinner-border spinner-border-sm"></span>
        ) : (
          "Consultar"
        )}
      </button>
    </form>
  );
};

export default ValidateUser;
